var _defs, _rect, _rect2, _rect3, _polygon, _path, _circle, _path2, _polygon2, _polygon3, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 81.75 133.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#92a9ad;}.cls-2{fill:#f2f2f2;}.cls-3{fill:#565656;}.cls-4{fill:#62717a;}.cls-5,.cls-6{fill:#fff;}.cls-6{opacity:0.66;}.cls-7{fill:#e8c78e;}.cls-8{fill:#d1ab7d;}.cls-9{fill:#E30613;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Facil") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 15.18,
    y: 2.91,
    width: 44.87,
    height: 85.96,
    rx: 2.67,
    ry: 2.67
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 18.1,
    y: 9.31,
    width: 39.02,
    height: 66.87,
    rx: 1.7,
    ry: 1.7
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 31.54,
    y: 5.34,
    width: 12.14,
    height: 1.5,
    rx: 0.75,
    ry: 0.75
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "16 3.67 16 3.67 15.99 3.68 16 3.67"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M57.39,88.86H17.87a2.66,2.66,0,0,1-2.67-2.67V5.58a2.61,2.61,0,0,1,.67-1.79s-2,2.28-2.1,2.37l-.1.12a2.62,2.62,0,0,0-.51,1.55V88.45a2.68,2.68,0,0,0,2.67,2.67H55.36a2.66,2.66,0,0,0,1.69-.62l.06,0,2.09-2.3A2.66,2.66,0,0,1,57.39,88.86Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 37.62,
    cy: 41.76,
    r: 10.63
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M35.57,46.33a.7.7,0,0,1-.5-.21l-3.64-3.64a.71.71,0,0,1,1-1l3.14,3.13,7.23-7.22a.7.7,0,0,1,1,0,.71.71,0,0,1,0,1l-7.72,7.72A.73.73,0,0,1,35.57,46.33Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "15.18 50.69 15.18 70.27 51.2 2.91 40.73 2.91 15.18 50.69"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "15.18 80.6 56.72 2.91 52.89 2.91 15.18 73.44 15.18 80.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M13.16,32.69a25.79,25.79,0,0,0-3.43-2.13c-1.36-.49-3.43-.49-5.39,2.13s-.58,6.35,1,7.68c1,.82,7.84,6.69,7.84,6.69Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M21.19,68.1s1.51.83,2.49,0a7,7,0,0,0,2-5.24c-.12-2.23-1.31-3.53-3-4.83C20.37,56.25,15,53,13.07,51.21a3.39,3.39,0,0,0-4.84,0C7,52.43,5.22,56,7.51,58.07c0,0-2.45,4.09-2.45,5.89A6.69,6.69,0,0,0,6.51,66.8h0s-2.1,7.33,0,9.22,8,6.63,10.11,6.86c1,.1,3.51-.95,3.16-4.64h0c1.41.82,1.7.89,2.82.6s3.38-2.61,3.23-4.43C25.63,72.38,21.19,68.1,21.19,68.1Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M60.05,51.42V86.2a2.62,2.62,0,0,1-1,2.06c.05,0,.11-.07.15-.11l-2.09,2.3-.06,0a2.66,2.66,0,0,1-1.69.62H22.1l14,12.75a19.73,19.73,0,0,1,4.18,5.39l8.43,16,23.95-11.07L68.18,104c-1-2.2-1.12-5.64-1-8,.38-5.55,2.43-10.25,2.54-15.34.15-7.23-.66-11.92-.66-17.28,0-10.54,1-11.4.94-15a3.23,3.23,0,0,0-3.29-3.12c-3,0-4.64,1.79-6,4.58Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M58.83,88.44l-.14.07Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M58.38,88.67l-.07,0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M7.51,58.07A32.39,32.39,0,0,0,5.8,61.39s1.35-1.68,2.08-1.11c2.52,2,13.31,7.82,13.31,7.82A81.24,81.24,0,0,1,7.51,58.07Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M6.51,66.8a24.13,24.13,0,0,0-.92,6.66s1.08-3.72,2.14-2.83c4.36,3.71,12,7.61,12,7.61C9.33,71.71,6.51,66.8,6.51,66.8Z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 39.76,
    y: 103.36,
    width: 36.4,
    height: 21.42,
    rx: 1.74,
    ry: 1.74,
    transform: "translate(-40.62 32.5) rotate(-23.46)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacil);
export default __webpack_public_path__ + "static/media/facil.772269eff717df8e957ac2e945cf38df.svg";
export { ForwardRef as ReactComponent };